import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';
import {runSLPDatePickerOpenedExperiment} from '../../../utils/experiments';

import {useSettings} from './useSettings';

const defaultDatesSettings = {
    dayData: {},
    startDayDataId: '',
    endDayDataId: '',
    selectedDayDataId: '',
    isOpen: false,
    isSelecting: undef,
    readOnly: false,
    showContinueButton: true
};

function useDatesSettings(props, systemOptions, abacusStore) {
    const {
        datesSettings: propsDatesSettings
    } = props;

    const overrideDatesSettings = {
        isOpen: runSLPDatePickerOpenedExperiment({shouldLogExperiment: true}, abacusStore, systemOptions) || undef
    };

    const {
        initialSettings: initialDatesSettings,
        settings: datesSettings,
        changeSettings: changeDatesSettings
    } = useSettings(defaultDatesSettings, propsDatesSettings, overrideDatesSettings);

    const result = {
        initialDatesSettings,
        datesSettings,
        changeDatesSettings
    };

    useDebugValue(result);

    return result;
}

export {useDatesSettings};
